/** @internal */
export const MessageIds = Object.freeze({
  calibration: 'room.watchdog.calibration',
  gamepad: 'room.watchdog.gamepad',
  network: 'room.watchdog.network'
});
